import {
  Globe,
  Lock,
  ShieldCheck,
  Brain,
  DatabaseBackup,
  Eye,
} from 'lucide-react';

const items = [
  {
    icon: Globe,
    title: 'EU-Hosting',
    description:
      'Alle Daten werden ausschließlich in zertifizierten EU-Rechenzentren gehostet — DSGVO-konform und souverän.',
  },
  {
    icon: Lock,
    title: 'Verschlüsselung',
    description:
      'AES-256-Verschlüsselung im Ruhezustand und TLS 1.2+ bei der Übertragung über alle Dienste hinweg.',
  },
  {
    icon: ShieldCheck,
    title: 'Zugriffskontrollen',
    description:
      'Rollenbasierte Zugriffskontrolle, Least-Privilege-Prinzipien und detailliertes Audit-Logging.',
  },
  {
    icon: Brain,
    title: 'KI-Sicherheit',
    description:
      'Kundendaten werden niemals für das Training oder die Weiterentwicklung von Modellen verwendet.',
  },
  {
    icon: DatabaseBackup,
    title: 'Backups & Wiederherstellung',
    description:
      'Automatische Backups, Point-in-Time-Recovery und dokumentierte Disaster-Recovery-Verfahren.',
  },
  {
    icon: Eye,
    title: 'Privacy by Design',
    description:
      'Ihre Daten sind durch technische, administrative und organisatorische Schutzmaßnahmen geschützt.',
  },
];

export function Security() {
  return (
    <section
      id="security"
      className="flex flex-col items-center justify-center w-full relative"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-0 -z-10 w-full bg-gradient-to-b from-background via-secondary to-secondary" />
      </div>
      <div className="w-full h-full relative">
        <div className="p-10 md:p-14">
          <div className="max-w-xl mx-auto flex flex-col items-center justify-center gap-2">
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-center text-balance text-[#111]">
              Vertrauen & Sicherheit
            </h2>
            <p className="text-muted-foreground text-center text-balance font-medium">
              Sicherheit ist unser Fundament:
              Ihre Daten werden ausschließlich in der EU gehostet und DSGVO-konform verarbeitet.
            </p>
          </div>
        </div>
        <div className="border-b w-full" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.title}
              className="flex flex-col gap-y-2 items-center justify-center py-8 px-4 border-b transition-colors hover:bg-secondary/20 last:border-b-0 md:[&:nth-child(2n+1)]:border-r md:[&:nth-child(n+5)]:border-b-0 lg:[&:nth-child(3n)]:border-r-0 lg:[&:nth-child(n+4)]:border-b-0 lg:border-r"
            >
              <div className="flex flex-col gap-y-2 items-center">
                <div className="bg-gradient-to-b from-primary to-primary/80 p-2 rounded-lg text-white">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-medium text-card-foreground text-center text-balance">
                  {item.title}
                </h3>
              </div>
              <p className="text-sm text-muted-foreground text-balance text-center max-w-md mx-auto">
                {item.description}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
